(function() {
    'use strict';

    angular
        .module('app')
        .directive('attachToBody', attachToBody);

    attachToBody.$inject = ['$window'];
    
    function attachToBody ($window) {
        // Usage:
        //     <attach-to-body></attach-to-body>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            $(document.body).prepend(element);
        }
    }

})();